import type { ProductCardProps } from '@coursera/cds-core';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

export const getStatusTagRedesignExperimentVariant = () => {
  const statusTagRedesignVariant = GrowthDiscoveryEpicClient.preview('statusTagRedesign');
  let productCardExperimentVariant: ProductCardProps['experimentVariant'] = 'control';
  if (statusTagRedesignVariant !== 'control') {
    productCardExperimentVariant = statusTagRedesignVariant === 'A' ? 'test1.3' : 'test1.4';
  }
  return { statusTagRedesignVariant, productCardExperimentVariant };
};
